import { Component, OnInit, inject } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ApplicationDenyReason, ApplicationDenyRequestPayload, ApplicationStatus } from 'src/app/models/user.model';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-denydialog',
  standalone: false,
  templateUrl: './denydialog.component.html',
  styleUrl: './denydialog.component.css'
})
export class DenyDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<DenyDialogComponent>>(MatDialogRef);
  private auth = inject(AuthService);
  data = inject(MAT_DIALOG_DATA);

  form: UntypedFormGroup;

  ngOnInit(): void {
    this.form = new UntypedFormGroup({
      duplicateAccount: new UntypedFormControl(''),
      duplicateAccountEmail: new UntypedFormControl(
        this.data.duplicateEmail || '', Validators.email),
      notEnoughRooms: new UntypedFormControl(''),
      custom: new UntypedFormControl(''),
      customInstructions: new UntypedFormControl(''),
      ccMe: new UntypedFormControl(true)
    });

    // Update duplicateAccountEmail validation based on duplicateAccount checkbox
    this.form.get('duplicateAccount').valueChanges.subscribe((checked) => {
      const emailControl = this.form.get('duplicateAccountEmail');
      if (checked) {
        emailControl.setValidators([Validators.required, Validators.email]);
      } else {
        emailControl.setValidators([Validators.email]);
      }
      emailControl.updateValueAndValidity();
    });
  }

  getPayload(): ApplicationDenyRequestPayload {
    const reasons: ApplicationDenyReason[] = [];
    if (this.form.value.duplicateAccount) {
      reasons.push(ApplicationDenyReason.DUPLICATE_ACCOUNT);
    }
    if (this.form.value.notEnoughRooms) {
      reasons.push(ApplicationDenyReason.NOT_ENOUGH_ROOMS);
    }
    if (this.form.value.custom && this.form.value.customInstructions) {
      reasons.push(ApplicationDenyReason.CUSTOM);
    }
    const payload: ApplicationDenyRequestPayload = {
      status: ApplicationStatus.DENIED,
      reasons
    };
    if (this.form.value.duplicateAccount && this.form.value.duplicateAccountEmail) {
      payload.duplicateAccountEmail = this.form.value.duplicateAccountEmail;
    }
    if (this.form.value.custom && this.form.value.customInstructions) {
      payload.customInstructions = this.form.value.customInstructions;
    }
    if (this.form.value.ccMe) {
      payload.ccEmail = this.auth.currentUser.appEmail || this.auth.currentUser.email;
    }
    return payload;
  }

  formIsValid(): boolean {
    if (this.getPayload().reasons.length === 0) {
      return false;
    }
    // If duplicate account is selected, email is required
    if (this.form.value.duplicateAccount && !this.form.value.duplicateAccountEmail) {
      return false;
    }
    return true;
  }

  cancel() {
    this.dialogRef.close(false);
  }

  async submit() {
    await this.data.applicant.auth.setApplicationStatus(this.data.applicant.user.uid, this.getPayload());
    this.dialogRef.close(true);
    this.data.applicant.denyRequested();
  }
}
